import Vue from 'vue'
//import Plotly from 'plotly.js-basic-dist-min'
var Plotly = require('./custom_bundles//custom-plotly');
import axios from 'axios';
import { setOptions } from 'vue-gtag'

class Benchmark {
  constructor(isin, name) {
    this.isin = isin;
    this.name = name;

  }
}

class Competitor {
  constructor(isin, name) {
    this.isin = isin;
    this.name = name;
  }
}
var domain = "https://user.sigmafolio.net/"

Vue.mixin(


  {computed:{},
    methods: {
      enablePlugin () {
        let cookie = localStorage.getItem('cookie:accepted');
        if(cookie == 'true'){
          setOptions({
            enabled: true,
          })
          this.$gtag.optIn()
        }
      },
      setCookie(){
        setOptions({
          enabled: true,
        })
        this.$gtag.optIn()
      },

      refreshAccessToken: async function() {
        let refreshToken = localStorage.getItem('refresh-token');
        //console.log("refresh started", refreshToken);
        if(typeof refreshToken === 'undefined'){
          this.$router.push("/login");
       }else{
        await axios.post(domain + "api/token/refresh/", {
            'refresh': refreshToken
                  }
        ).then(response => {

            localStorage.setItem('access-token', response.data["access"]) // store the token in localstorage
            this.tokenValid = true;
        }).catch(e => {
          console.log(e);
          this.$router.push("/login");

        })
      }
      },

      verifyToken: async function() {
        let accessToken = localStorage.getItem('access-token');
        if(accessToken == null){
          this.$router.push("/login");
        }else{
                await axios.post(domain + "api/token/verify/", {
                    'token': accessToken
                          }
                ).then(response => {
                  console.log(response);
                  this.tokenValid = true;
                  }

                ).catch(e => {
                  console.log("verification failed");
                  console.log(e);
                  return this.refreshAccessToken();

                })
        }

      },
      refreshAccessTokenNoRouting: async function() {
        let refreshToken = localStorage.getItem('refresh-token');
        //console.log("refresh started", refreshToken);
        if(typeof refreshToken === 'undefined'){
          console.log("not logged in")
       }else{
        await axios.post(domain + "api/token/refresh/", {
            'refresh': refreshToken
                  }
        ).then(response => {

            localStorage.setItem('access-token', response.data["access"]) // store the token in localstorage
            this.tokenValid = true;
        }).catch(
          console.log("not logged in")
          )
      }
      },
      verifyTokenNoRouting: async function() {
        let accessToken = localStorage.getItem('access-token');
        if(accessToken == null){
          console.log('Du bist nicht angemeldet')
          this.tokenValid = false;
        }else{
                await axios.post(domain + "api/token/verify/", {
                    'token': accessToken
                          }
                ).then(response => {
                  console.log(response);
                  this.tokenValid = true;
                  }

                ).catch(e => {
                  console.log("verification failed");
                  console.log(e);
                  this.refreshAccessTokenNoRouting();

                })
        }

      },

    accessEndpoint: async function(url) {
      await this.verifyToken();
      let token = localStorage.getItem('access-token');
      if(token != null){
        return new Promise(function (resolve, reject) {
        console.log(domain);
          axios.get(domain + url,{
            headers: {
              'Authorization': 'Bearer ' + token
                    }
          }
            ).then(
              (response) => { 
                  var result = response.data;
                  resolve(result); 
              }, 
                  (error) => { 
                  reject(error); 
              } 
          ); 
      }); 
    }
  },

  accessEndpointNoVerify: async function(url) {
    let token = localStorage.getItem('access-token');
    if(token != null){
      return new Promise(function (resolve, reject) {
        axios.get(domain + url,{
          headers: {
            'Authorization': 'Bearer ' + token
                  }
        }
          ).then(
            (response) => { 
                var result = response.data;
                resolve(result); 
            }, 
                (error) => { 
                reject(error); 
            } 
        ); 
    }); 
  }
},

deleteAccountEndpoint: async function(payload, url){
  let token = localStorage.getItem('access-token');
  return new Promise(function (resolve, reject) { 
    axios.post(domain + url, payload,
      {headers: {
                  'Authorization': 'Bearer ' + token
                }
      }
            ).then(
        (response) => { 
            var result = response.data;
            localStorage.removeItem("access-token");
            localStorage.removeItem("refresh-token");
            console.log(result)
            resolve(result); 
        }, 
            (error) => { 
            reject(error); 
        } 
    ); 
}); 

},


    getEndpoint: async function(url){
      await axios.get(domain + url).then(response => {
        return response.data
      }).catch(e => {
        console.log(e)
      })
    },
    postEndpoint: async function(payload, url){
      let token = localStorage.getItem('access-token');
      return new Promise(function (resolve, reject) { 
        axios.post(domain + url, payload,
          {headers: {
                      'Authorization': 'Bearer ' + token
                    }
          }
                ).then(
            (response) => { 
                var result = response.data;
                console.log(result)
                resolve(result); 
            }, 
                (error) => { 
                reject(error); 
            } 
        ); 
    }); 
    
    },
    putEndpoint: async function(payload, url){
      let token = localStorage.getItem('access-token');
      return new Promise(function (resolve, reject) {
        axios.put(domain + url, payload,
          {headers: {
                      'Authorization': 'Bearer ' + token
                    }
          }
                ).then(
            (response) => {
                var result = response.data;
                resolve(result);
            },
                (error) => {
                reject(error);
            }
        );
    });

    },
    putEndpointNoVerify: async function(payload, url){
      return new Promise(function (resolve, reject) {
        axios.put(domain + url, payload
                ).then(
            (response) => {
                var result = response.data;
                resolve(result);
            },
                (error) => {
                reject(error);
            }
        );
    });

    },
    postEndpointNoVerify: async function(payload, url){
      return new Promise(function (resolve, reject) {
        axios.post(domain + url, payload
                ).then(
            (response) => {
                var result = response.data;
                resolve(result);
            },
                (error) => {
                reject(error);
            }
        );
    });

    },
    deleteEndpoint: async function(url, payload){
      let token = localStorage.getItem('access-token');
      await axios.delete(domain + url,
            {headers: {
                        'Authorization': 'Bearer ' + token
                      },
            data: payload
            }
        ).then(response => {
        return response.data
      }).catch(e => {
        console.log(e)
      })
    },
    formatPrice(value) {
      let val = (value/1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    formatNumber(value) {
      let val = (value/1).toFixed(0).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    formatPercentage(value) {
      let val = (value/1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".").concat(' %')
    },
    formatCurrency(value) {
      let val = (value/1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".").concat(' €')
    },
    plotPieChart: async function(diversification, divName) {
      let diversificationValues = Object.values(diversification)
      var MAX_LENGTH;

      if(window.innerWidth <= 800){
        MAX_LENGTH = 15;
      }else{
        MAX_LENGTH = 30;
      }
      
      let diversificationLabels = Object.keys(diversification)
      let diversificationLabelsShort = diversificationLabels.map(label => {
        if(label.length <= MAX_LENGTH){
          return label
        }else{
          return label.slice(0,MAX_LENGTH) + '...'
        }
      });

      var temp_labels = {};
      var count = diversificationLabelsShort.map(function(val) {
          return temp_labels[val] = (typeof temp_labels[val] === "undefined") ? 1 : temp_labels[val] + 1;
      });

      diversificationLabelsShort = diversificationLabelsShort.map(function(val, index) {
          return val + (temp_labels[val] != 1 ? '-' + count[index] : '');
      });
      
      var hoverinfo = diversificationLabels;
        var data = [{
          values: diversificationValues,
          labels: diversificationLabelsShort,
          type: 'pie',
          text:hoverinfo,
          hole: 0.35,
          hoverinfo:'text',
          textinfo: 'percent',
          automargin: true,
        }];

        var layout = {
          paper_bgcolor:'rgba(0,0,0,0)',
          plot_bgcolor:'rgba(0,0,0,0)',
          hovermode:'closest',
          colorway : ['#FFD2B9', '#FFC7A9', '#FFB48B','#FFA878', '#FF955C','#FF7D37' ,'#FF6816','#E0601A' ,'#C2581F','#AD5322','#994E25','#854827','#70432A' ,'#5C3E2D','#333333'  ],
          autosize:true,
          //showlegend: false,
          legend:{'font': {'color': 'black'}, 'bgcolor': 'transparent'},
          margin:{
            'l':10,
            'r':0,
            'b':15,
            't':30,
            'pad':0
        },
        useResizeHandler: true,
        style: {width: "100%", height: "100%"}
        };
      

        
        var config = {
            displayModeBar: false,
          };
          

          Plotly.newPlot(divName, data, layout, config);
      },
      normalizeValues: function(stockPrices) {
        var i;
        var normalized_values = [];  
      for (i = 0; i < stockPrices.length; i++) {
        normalized_values.push(100*stockPrices[i]/stockPrices[0]);
      }
    return normalized_values;
    
    },
      plotTimeSeries: async function(days, divName, assetDetail = false) {


        var days_options = [30, 180, 365, -1];
        var current;
        var i;
        for (i = 0; i < days_options.length; i++) {
            current = document.getElementById(days_options[i]);
          if(days == days_options[i])
          {
             current.className = "chart_time active";
          }
          else{
            current.className ="chart_time";
          }
  
        }

        this.benchmarkOption = true;
        this.timeOption = true;
        this.riskOption = false;
        this.dividendOption = false;
        this.days = days;
        if (assetDetail == false){
          var id_selected_benchmark = document.getElementById("benchmark-selector").value;
          var benchmarkName = this.stockData["index_benchmark"][id_selected_benchmark]["name"] // structure allows for multiple benchmarks in future
          var benchmarkDatesTotal = this.stockData["index_benchmark"][id_selected_benchmark]["dates"];
          var benchmarkDataTotal = this.stockData["index_benchmark"][id_selected_benchmark]["prices"];
        }else{
          benchmarkName = this.benchmarkData["name"] // structure allows for multiple benchmarks in future
          benchmarkDatesTotal = this.benchmarkData["dates"];
          benchmarkDataTotal = this.benchmarkData["prices"];
        }
        
        console.log("selected benchmark value", id_selected_benchmark, "days", days)

        var stockName = this.stockData["name"]
        var stockDatesTotal = this.stockData["dates"];
        var stockDataTotal = this.stockData["prices"];


        // additional slicing
        if (days != -1){ // send -1 to request full horizon
          stockDatesTotal = stockDatesTotal.slice(Math.max(stockDatesTotal.length - days, 0))
          stockDataTotal = stockDataTotal.slice(Math.max(stockDataTotal.length - days, 0))
          benchmarkDatesTotal = benchmarkDatesTotal.slice(Math.max(benchmarkDatesTotal.length - stockDatesTotal.length, 0)) // condition on portfolio length
          benchmarkDataTotal = benchmarkDataTotal.slice(Math.max(benchmarkDataTotal.length - stockDataTotal.length, 0))
        }

        else{
        // ensures that the total amount shown is restricted to length of the respective security
        benchmarkDatesTotal = benchmarkDatesTotal.slice(Math.max(benchmarkDatesTotal.length - stockDatesTotal.length, 0))
        benchmarkDataTotal = benchmarkDataTotal.slice(Math.max(benchmarkDataTotal.length - stockDataTotal.length, 0))

  }

        // normalize the data
        stockDataTotal = this.normalizeValues(stockDataTotal);
        benchmarkDataTotal = this.normalizeValues(benchmarkDataTotal);
  
        var stock = {
          x:stockDatesTotal,
          y:stockDataTotal,
          type:'lines',
          line:{'width':3, color:'#FF6816'},
    
          opacity:1,
          name: stockName

        };
        var benchmark = {
          x:benchmarkDatesTotal,
          y:benchmarkDataTotal,
          type:'lines',
          line:{'width':3, color:'#333333'},
          opacity:1,
          name:benchmarkName,
          

        };
    
    
            var data_prices = [stock, benchmark];
            var graphTitle;
            if (days == 30){
              graphTitle = 'Portfolioentwicklung (Letzter Monat)'
            }
            else{
              if (days == 180){
                graphTitle = 'Portfolioentwicklung (Letzte 6 Monate)'
              }
              else{
                if (days == 365){
                  graphTitle = 'Portfolioentwicklung (Letztes Jahr)'
                }
                else{
                  if (days == 1095){
                    graphTitle = 'Portfolioentwicklung (Letzte 3 Jahre)'
                  }
                  else{
                    if (days == -1){
                      graphTitle = 'Portfolioentwicklung (Total)'
                    }
                  }
                }
              }
            }
  
            var layout_prices = {
              title : graphTitle,
              paper_bgcolor:'#FFFFFF',
              plot_bgcolor:'#FFFFFF',
              hovermode:'x',
              autosize:true,
              legend:{'font': {'color': 'black'}, 'bgcolor': '#FFFFFF', "orientation": "h", y: -0.5},
              xaxis:{'color': 'black','gridcolor': '#FFFFFF', fixedrange: true},
              yaxis:{'color': 'black','gridcolor': '#EDEDED', fixedrange: true},
              margin:{
                'l':45,
                'r':25,
                'b':20,
                't':40,
                'pad':2
            },

            };
        
            var config = {
              displayModeBar: false,
            };
            
            Plotly.newPlot(divName, data_prices, layout_prices, config);
      },
      plotBasicTimeSeries: function(divName) {

        // normalize the data
        console.log("portfolio", this.portfolio)
        let dates = this.portfolio[this.assetModalIndex]['trend_plot']["date"];
        let prices = this.portfolio[this.assetModalIndex]['trend_plot']["price"];
        let lower_boundaries = this.portfolio[this.assetModalIndex]['trend_plot']["lower_boundary"];
        let upper_boundaries = this.portfolio[this.assetModalIndex]['trend_plot']["upper_boundary"];
  
        var price = {
          x:dates,
          y:prices,
          opacity:1,
          name: this.portfolio[this.assetModalIndex]["name"],
          type: 'line',
          line: {
            color:'#FF6816',
            width: 3
          },
          showlegend: true,
          hovertemplate: '%{y} €<extra></extra>'
        };
        var lower_boundary = {
          x:dates,
          y:lower_boundaries,
          opacity:1,
          name:'Trendkanal',
          type: 'line',
          line: {
            width: 2,
            color:'#333333'
          },
          showlegend: true,
          hovertemplate: '%{y} €<extra></extra>'
        };
    
        var upper_boundary = {
          x:dates,
          y:upper_boundaries,
          opacity:1,
          name:'Trendkanal',
          fill: 'tonexty',
          fillcolor: 'rgba(51, 51, 51, 0.2)',
          type: 'line',
          line: {
            color:'#333333',
            width: 2
          },
          showlegend: false,
          hovertemplate: '%{y} €<extra></extra>'
        };
        var data_prices;
          if (lower_boundaries[0] == 0){
            data_prices = [price];
          }
          else{
            data_prices = [lower_boundary, upper_boundary,price];
          }
  
    
          var num_observations = dates.length;

            var layout_prices = {
              paper_bgcolor:'#FFFFFF',
              plot_bgcolor:'#FFFFFF',
              hovermode:'x',
              autosize:true,
              legend:{'font': {'color': 'black'}, 'bgcolor': '#FFFFFF', "orientation": "h", y: -0.2},
              xaxis:{'color': 'black','gridcolor': '#FFFFFF', fixedrange: true, showticklabels: true, tickvals: [1,Math.round( num_observations / 2 ), num_observations-10],tickformat: '%Y.%m.%d', type:'category'},
              yaxis:{'color': 'black','gridcolor': '#EDEDED', fixedrange: true},
              margin:{
                'l':30,
                'r':5,
                'b':5,
                't':5,
                'pad':2
            },
  
  
            };
        
            var config = {
              displayModeBar: false,
            };
            
            Plotly.newPlot(divName, data_prices, layout_prices, config);
      },
      plotTrendPlot: function(divName) {

        let dates = this.trendplot["date"];
        let prices = this.trendplot["price"];

        var price = {
          x:dates,
          y:prices,
          opacity:1,
          name: 'Kursverlauf',
          type: 'line',
          line: {
            color:'#FF6816',
            width: 3
          },
          showlegend: true,
          hovertemplate: '%{y} <extra></extra>'
        };

        let boundariesExist = 'lower_boundary' in this.trendplot;
        //console.log("boundariesExist:", boundariesExist)
        var lower_boundaries;
        var upper_boundaries;

        if(boundariesExist){
          lower_boundaries = this.trendplot["lower_boundary"];
          upper_boundaries = this.trendplot["upper_boundary"];

          var lower_boundary = {
            x:dates,
            y:lower_boundaries,
            opacity:1,
            name:'Trendkanal',
            type: 'line',
            line: {
              width: 2,
              color:'#333333'
            },
            showlegend: true,
            hovertemplate: '%{y} <extra></extra>'
          };
      
          var upper_boundary = {
            x:dates,
            y:upper_boundaries,
            opacity:1,
            name:'Trendkanal',
            fill: 'tonexty',
            fillcolor: 'rgba(51, 51, 51, 0.2)',
            type: 'line',
            line: {
              color:'#333333',
              width: 2
            },
            showlegend: false,
            hovertemplate: '%{y} <extra></extra>'
          };
        }




        var data_prices;
          if (boundariesExist == false || (lower_boundaries[0] == 0)){
            data_prices = [price];
          }
          else{
            data_prices = [lower_boundary, upper_boundary,price];
          }
          var num_observations = dates.length;

  
    
            var layout_prices = {
              paper_bgcolor:'rgba(0,0,0,0)',
              plot_bgcolor:'rgba(0,0,0,0)',
              hovermode:'x',
              autosize:true,
              legend:{'font': {'color': 'black'}, 'bgcolor': 'rgba(0,0,0,0)', "orientation": "h", y: -0.2},
              xaxis:{'color': 'black','gridcolor': 'rgba(0,0,0,0)', fixedrange: true, showticklabels: true, tickvals: [1,Math.round( num_observations / 2 ), num_observations-5], tickformat: '%Y.%m.%d', type:'category'},
              yaxis:{'color': 'black','gridcolor': 'rgba(0,0,0,0)', fixedrange: true},
              margin:{
                'l':35,
                'r':15,
                'b':5,
                't':5,
                'pad':2
            },


            };
        
            var config = {
              displayModeBar: false,
            };
            
            Plotly.newPlot(divName, data_prices, layout_prices, config);
      },

    
      buttonActivation:  function(headerid, btnClass) {
        // Changes active button
        var header = document.getElementById(headerid);
        var btns = header.getElementsByClassName(btnClass);
        for (var i = 0; i < btns.length; i++) {
          btns[i].addEventListener("click", function() {
          var current = header.getElementsByClassName("active");
    
          if(current.length > 0){
            current[0].className = current[0].className.replace(" active", "");
          }
          this.className += " active";
          });
        }
        },
        getActiveTab: function(headerid){
          var header = document.getElementById(headerid);
          //var btns = header.getElementsByClassName(btnClass);
          var current = header.getElementsByClassName("active");
          return current[0].id
        },
        showErrorNotification: function(customSpinner = null){
          switch(customSpinner){
            case 'performance':
              this.showPerformanceSpinner = false;
              break;
            default:
              this.showSpinner = false;
          }
          
          setTimeout(() => this.isEndpointError = true, 200)
          setTimeout(() => this.isEndpointError = false, 3000)
        },
        addBenchmarks(){
          console.log("executed", this.benchmark_data["index_benchmark_prices"]);
          var keys = Object.keys(this.benchmark_data["index_benchmark_prices"]);
          for(var i=0; i<keys.length; i++){
              var key = keys[i];
              this.benchmarks.push(new Benchmark(key, this.benchmark_data["index_benchmark_prices"][key]["name"]));
          }
          console.log("benchmarks", this.benchmarks)
          this.selected = this.benchmarks[0].name;
          this.benchmarkIsin = this.benchmarks[0].isin;
        },
        updateGraph(){
          var e = document.getElementById("benchmark-selector");
          this.benchmarkIsin = e.options[e.selectedIndex].value;
          this.loadData()
        },

        showAvailableExchanges: function() {
          this.buttonActivation("nav-bar-stock-info", "btnStockInfo");
          document.getElementById("tableProfile").style.display = "none";
          document.getElementById("competitor-div").style.display = "none";
          document.getElementById("map-div").style.display = "flex";
        },
        
    splitDateYear(dateInput){
      let dateSplitted = dateInput.split('-')
  
      return dateSplitted[0];
    },
    getUniqueYearsFromList(inputList){
      var outputList = []
      for (var item in inputList){
        let splitted = this.splitDateYear(inputList[item])
        outputList.push(splitted)
      }
      outputList = [...new Set(outputList)]

      return outputList
    },

    getCheckedInputs(input_classes){ 
      // function that retrieves all checked inputs and systematically saves them in json structure that
      // may be posted to API Endpoint
      var filter = {};
      for (var i = 0; i < input_classes.length; i++) {
        var inputs = document.getElementsByClassName(input_classes[i]);
        var checked_inputs = [];
        for (var z = 0; z < inputs.length; z++) {
          var input = inputs[z];
          if (document.getElementById(input.id).checked == true) {
              checked_inputs.push(input.id);
          }
    }
    filter[input_classes[i]] = checked_inputs;
  }
  return filter;
    },

    fillCompetitorList(){
      var counter;
      var keys = ["similar_isin", "similar_name"]
      var value;
      var competitor;
      // check if competitors already set
      if (this.competitors.length == 0){
         this.competitors = [];
      for (var i = 0; i < this.securityInformation["competitors"].length; i++) {
        competitor = []
        for (counter in keys) {
            value = this.securityInformation["competitors"][i][keys[counter]];
            competitor.push(value);
        }
        this.competitors.push(new Competitor(competitor[0],competitor[1]));
      }
  
      if(this.competitors.length === 0){
        this.rowDataIsEmpty = true;
      }
      }
     
    },
  
    executeAdvancedSearch: async function(payload, url){
      await this.verifyToken();
      console.log("executedSearch");
      let token = localStorage.getItem('access-token');

      axios.post(domain +url, payload, {
        headers: {
          'Authorization': 'Bearer ' + token
                }
      }).then(response => {
        // needs to be executed within here, as otherwise does not wait for response
        this.stocksFound = response.data;
        this.addStocks();
      }).catch(e => {
        console.log(e)
      })
    },
  

}})